"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefiPassportSkinFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var DefiPassportSkinFactory = /** @class */ (function (_super) {
    __extends(DefiPassportSkinFactory, _super);
    function DefiPassportSkinFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    DefiPassportSkinFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    DefiPassportSkinFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    DefiPassportSkinFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    DefiPassportSkinFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    DefiPassportSkinFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return DefiPassportSkinFactory;
}(contracts_1.ContractFactory));
exports.DefiPassportSkinFactory = DefiPassportSkinFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "BaseURISet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
        ],
        name: "NameAndSymbolChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
        ],
        name: "setNameAndSymbol",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
